module.exports = __webpack_public_path__ + "img/data-sync.4a13e95e.png";